<div class="business-button selection-tile" [class.selected]="selected" [class.suspended]="user.status.includes('suspended')">
    <div class="business-name d-flex align-items-center gap--8">
        <h4>{{ businessName }}</h4>
        <small class="counter" *ngIf="notificationsCount">{{ notificationsCount }}</small>
    </div>
    <small class="user-type-label">{{ capitalizeFirstChar(user.role) }}</small>
</div>